import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const DOWNLOAD_LEAD_CAPTURE = 'DOWNLOAD_LEAD_CAPTURE';
export const DOWNLOAD_LEAD_CAPTURE_SUCCESS = 'DOWNLOAD_LEAD_CAPTURE_SUCCESS';
export const DOWNLOAD_LEAD_CAPTURE_FAILURE = 'DOWNLOAD_LEAD_CAPTURE_FAILURE';

// Action Creators
export const downloadLeadCapture = () => ({
  type: DOWNLOAD_LEAD_CAPTURE,
});

export const downloadLeadCaptureSuccess = (data) => ({
  type: DOWNLOAD_LEAD_CAPTURE_SUCCESS,
  payload: data,
});

export const downloadLeadCaptureFailure = (error) => ({
  type: DOWNLOAD_LEAD_CAPTURE_FAILURE,
  payload: error,
});

// Thunk Function
export const downloadLeadCaptureCallAPI = (data, external) => {
  return async (dispatch) => {
    dispatch(downloadLeadCapture());
    try {
      const response = await getMethodWithToken(url.leadCapture + data, true);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(downloadLeadCaptureSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
        dispatch(downloadLeadCaptureFailure(response?.data));
      }
    } catch (error) {
      dispatch(downloadLeadCaptureFailure(error?.message));
    }
  };
};
